module.exports = __webpack_public_path__ + "media/MercedesGlk1406.fba31336.mp4";